import { useState } from "react";
import { Badge, Button, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CardItem from "./CardItem";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import { setSearch } from "../../../../store/actions/AuthActions";
import ReportsService from "../../../../services/ReportsService";
import Pagination from "../Pagination/Pagination";
import print from "../../../Enums/Print";
import { ExportExcel } from "../../../Enums/Export";

const StaffDrivers = () => {
	const tabs = ["staff", "drivers"];
	const [selectTab, setSelectTab] = useState("staff");
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const dispatch = useDispatch();
	const reportsService = new ReportsService();
	const search = useSelector((state) => state.auth.search);

	const printPage = () => {
		let headRow =
			selectTab === "staff"
				? [
						Translate[lang].name,
						Translate[lang].phone,
						Translate[lang].email,
						Translate[lang].roles,
						Translate[lang].licence_number,
						Translate[lang].zone,
						Translate[lang].work_shift,
				  ]
				: [
						Translate[lang].name,
						Translate[lang].phone,
						Translate[lang].email,
						Translate[lang].licence_number,
						Translate[lang].zone,
						Translate[lang].work_shift,
				  ];
		let dataInfo = data?.map((res) => {
			let info = {
				username: res?.username,
				phone: res.phone,
				email: res.email,
			};
			if (selectTab === "staff")
				info["roles"] = res?.admin_permissions[0]?.admin_role?.name;
			info["licence_number"] = res.license_number;
			info["zone"] =
				selectTab === "staff"
					? !!res?.admin_zones?.length
						? res?.admin_zones?.map((res1) => {
								return lang === "en" ? res1.zone?.name_en : res1.zone?.name_ar;
						  })
						: "-"
					: `<Badge variant='warning light'>
						${lang === "en" ? res.zone?.name_en : res.zone?.name_ar}
					</Badge>`;
			info["work_shift"] = res.work_shift?.name;
			return info;
		});
		print(selectTab, headRow, lang, dataInfo);
	};

	return (
		<>
			<div className="tabs-div mb-4">
				{tabs?.map((tab, index) => {
					return (
						<p
							key={index}
							className={`${tab === selectTab ? "activeP" : ""}`}
							onClick={() => {
								setSelectTab(tab);
								dispatch(setSearch(""));
								setShouldUpdate((prev) => !prev);
							}}>
							{Translate[lang][tab]}
						</p>
					);
				})}
			</div>
			<div className="d-flex justify-content-between mb-4 align-items-center">
				<span
					style={{
						fontWeight: "600",
						textTransform: "capitalize",
						color: "#000",
					}}>
					{Translate[lang][selectTab]}
				</span>
				<div className="d-flex gap-8">
					<Button
						variant="outline-primary"
						onClick={() =>
							ExportExcel(
								data?.map((res) => {
									let info = {};
									info["name"] = res?.username;
									info["phone"] = res.phone;
									info["email"] = res.email;
									if (selectTab === "staff")
										info["roles"] = !!res?.admin_permissions?.length
											? res?.admin_permissions[0]?.admin_role?.name
											: "-";
									info["licence_number"] = res?.license_number;
									info["zone"] =
										selectTab === "staff"
											? !!res?.admin_zones?.length
												? res?.admin_zones?.map((res1) => {
														return lang === "en"
															? res1.zone?.name_en
															: res1.zone?.name_ar;
												  })
												: "-"
											: lang === "en"
											? res.zone?.name_en
											: res.zone?.name_ar;
									info["work_shift"] = res.work_shift?.name;
									return info;
								})
							)
						}>
						<i className="las la-download fs-20" /> {Translate[lang].export}
					</Button>
					<Button variant="primary" onClick={() => printPage()}>
						<i className="las la-print fs-20" /> {Translate[lang].print}
					</Button>
				</div>
			</div>
			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>{Translate[lang].name}</strong>
									</th>
									<th>
										<strong>{Translate[lang].phone}</strong>
									</th>
									<th>
										<strong>{Translate[lang].email}</strong>
									</th>
									{selectTab === "staff" && (
										<th>
											<strong>{Translate[lang].roles}</strong>
										</th>
									)}
									<th>
										<strong>{Translate[lang].licence_number}</strong>
									</th>
									<th>
										<strong>{Translate[lang].zone}</strong>
									</th>
									<th>
										<strong>{Translate[lang].work_shift}</strong>
									</th>
									<th>
										<strong>{Translate[lang].licence}</strong>
									</th>
									{/* {selectTab === "drivers" && (
										<th>
											<strong>{Translate[lang].customer_rating}</strong>
										</th>
									)} */}
									{/* <th>
										<strong>{Translate[lang].civil_id}</strong>
									</th> */}
									{selectTab === "staff" && (
										<th>
											<strong>{Translate[lang].status}</strong>
										</th>
									)}
								</tr>
							</thead>

							<tbody className="table-body">
								{data?.map((item, index) => {
									return (
										<CardItem
											index={index}
											key={index}
											item={item}
											selectTab={selectTab}
											setShouldUpdate={setShouldUpdate}
										/>
									);
								})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && !loading && <NoData />}
					<Pagination
						setData={setData}
						service={reportsService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						type={selectTab}
					/>
				</div>
			</div>
		</>
	);
};

export default StaffDrivers;
